import script from "./logisticsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./logisticsDialog.vue?vue&type=script&setup=true&lang=js"

import "./logisticsDialog.vue?vue&type=style&index=0&id=0d44ebb4&lang=scss&scoped=true"

import exportComponent from "/home/kain/brighten-legacy/brightenflower2024-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d44ebb4"]])

export default __exports__